// extracted by mini-css-extract-plugin
export default {"tabListItem":"tab-module__tabListItem__vr8Si","calendar":"tab-module__calendar__NQJKF","active":"tab-module__active__D51d6","providers":"tab-module__providers__UfhgH"};